import React from "react";
import { FaTimes, FaEye, FaEyeSlash } from "react-icons/fa";

interface SettingsModalProps {
  onionSkinsEnabled: boolean;
  onionSkinsBefore: number;
  onionSkinsAfter: number;
  onToggleOnionSkins: (enabled: boolean) => void;
  onSetOnionSkinsBefore: (count: number) => void;
  onSetOnionSkinsAfter: (count: number) => void;
  onClose: () => void;
}

export default function SettingsModal({
  onionSkinsEnabled,
  onionSkinsBefore,
  onionSkinsAfter,
  onToggleOnionSkins,
  onSetOnionSkinsBefore,
  onSetOnionSkinsAfter,
  onClose,
}: SettingsModalProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content settings-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Settings</h2>
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="settings-section">
            <h3>Onion Skins</h3>
            <p className="settings-description">
              Preview frames before and after the current frame to help with animation continuity.
            </p>

            <div className="settings-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={onionSkinsEnabled}
                  onChange={(e) => onToggleOnionSkins(e.target.checked)}
                />
                <span className="checkbox-custom"></span>
                <span className="checkbox-text">
                  {onionSkinsEnabled ? <FaEye /> : <FaEyeSlash />}
                  Enable Onion Skins
                </span>
              </label>
            </div>

            <div className="settings-group">
              <label htmlFor="onion-before">Frames Before</label>
              <input
                id="onion-before"
                type="number"
                min="0"
                max="10"
                value={onionSkinsBefore}
                onChange={(e) => onSetOnionSkinsBefore(parseInt(e.target.value, 10))}
                disabled={!onionSkinsEnabled}
              />
            </div>

            <div className="settings-group">
              <label htmlFor="onion-after">Frames After</label>
              <input
                id="onion-after"
                type="number"
                min="0"
                max="10"
                value={onionSkinsAfter}
                onChange={(e) => onSetOnionSkinsAfter(parseInt(e.target.value, 10))}
                disabled={!onionSkinsEnabled}
              />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
